const o="5.3.2";export{o as VERSION};
